import '@babel/polyfill';
import 'raf/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import configureStore from './ConfigStore';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
const { persistor, store } = configureStore();

const Main = () => {
  return (
    <Provider store={store}>
       <PersistGate persistor={persistor}>
        <Router>
          <App />
        </Router>
      </PersistGate>
    </Provider>
  );
}


ReactDOM.render(
  <Main />,
  document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js